const calculateHeaderHeight = ()=>{
    var ref, ref1;
    return ((ref = document === null || document === void 0 ? void 0 : document.querySelector('.header')) === null || ref === void 0 ? void 0 : ref.clientHeight) || //if the regular header height is 0 we check the mobile header
    ((ref1 = document === null || document === void 0 ? void 0 : document.querySelector('.header__header')) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) || 0;
};

export { calculateHeaderHeight };
//# sourceMappingURL=calculate-header-height.js.map
